<template>
  <div class="charts">
    <div class="select-searchmain1">
      <div class="earch-input">
        <div class="input-li2">
          <!-- <p>查询日期：</p> -->
          <el-date-picker
            size="small"
            :clearable="false"
            style="width: 100%"
            v-model="dates"
            value-format="yyyy-MM"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="input-li">
          <!-- <p>选择辖区：</p> -->
          <el-select
            size="small"
            :clearable="false"
            filterable
            style="width: 100%"
            v-model="searchParams.companyId"
            placeholder="请选择企业"
          >
            <el-option
              v-for="item in companies"
              :key="item.companyId"
              :label="item.name"
              :value="item.companyId"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="search-action">
        <el-button
          size="small"
          icon="el-icon-search"
          type="primary"
          @click="getViews()"
          >查询</el-button
        >
        <!-- <el-button size="small" icon="el-icon-refresh" plain @click="onReset()">重置</el-button> -->
      </div>
    </div>
    <div class="chart-content">
      <div class="chart-card">
        <div class="chart-title" style="justify-content: center">
          企业情况统计
        </div>
        <div class="chart-main" id="companies-chart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">
          <div>{{ companyName }}</div>
          <el-tag>计划实际对比</el-tag>
        </div>
        <div class="chart-main" id="planVsRealOutPut-chart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">
          <div>{{ companyName }}</div>
          <el-tag>危废数据</el-tag>
        </div>
        <div class="chart-main" id="dangerData-chart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">
          <div>{{ companyName }}</div>
          <el-tag>危废种类</el-tag>
        </div>
        <div class="chart-main" id="dangerType-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      companyName: "",
      searchParams: {
        startDate: "",
        endDate: "",
        companyId: null,
      },
      dataSource: [],
      manageCategory: [],
      types: [],
      dates: [],
      companies: [],
      companiesData: [],
      companyDangerTypeData: [],
      companyDangerWasterData: [],
      planVsRealOutPut: [],
    };
  },
  methods: {
    //切换图表类型

    //切换数据类型
    toogleType() {
      this.getViews();
    },
    getParams() {
      const url = this.$api.companies.getCompaniesSelect;
      this.$axios.get(url, null, false).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.data;
          this.companies = data;
          this.searchParams.companyId = data[0].companyId;
          this.getViews();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getViews() {
      if (this.dates && this.dates.length > 0) {
        this.searchParams.startDate = this.dates[0];
        this.searchParams.endDate = this.dates[1];
      } else {
        this.searchParams.startDate = this.searchParams.endDate = null;
      }
      const params = {
        ...this.searchParams,
      };
      if (this.searchTypes && this.searchTypes.length > 0) {
        params.types = this.searchTypes.join(",");
      }
      const url = this.$api.statistics.getCompanyDangerView;
      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let {
            companyName,
            companiesData,
            companyDangerTypeData,
            companyDangerWasterData,
            planVsRealOutPut,
          } = res.data.data;
          this.companiesData = companiesData;
          this.companyDangerTypeData = companyDangerTypeData;
          this.companyDangerWasterData = companyDangerWasterData;
          this.planVsRealOutPut = planVsRealOutPut;

          this.companyName = companyName;
          this.drawCompaniesCharts();
          this.drawPlanVsRealCharts();
          this.drawDangerDataCharts();
          this.drawDangerTypeCharts();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    drawCompaniesCharts() {
      const pieData = this.companiesData;

      const option = {
        tooltip: {
          trigger: "item",
          // formatter: "{a}{b}\n \n \t{c} 吨",
          formatter: function (params) {
            let { name, value, marker } = params;
            return `${marker} ${name} <br /> ${value} 吨`;
          },
        },

        legend: {
          right: "0px",
          top: "center",
          orient: "vertical",
        },
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: pieData.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            center: ["35%", "50%"],
            label: {
              show: true,
              normal: {
                formatter: "{b}\n \n \t{c} 吨",
                textStyle: {
                  fontSize: 14,
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
              // length2: 50,
              // length: 20,
              // lineStyle: {
              //   color: '#000'
              // }
            },
            data: pieData,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("companies-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drawPlanVsRealCharts() {
      const keys = this.planVsRealOutPut.map((item) =>
        item.key.substring(0, 4)
      );
      const outPuts = this.planVsRealOutPut.map((item) => item.outPut);
      const planOutPuts = this.planVsRealOutPut.map((item) => item.planOutPut);
      const dataName = ["危废计划产生量（吨）", "实际产生量（吨）"];
      const option = {
        // color: ['#5C87E5', '#7BB9C2'],

        tooltip: {
          trigger: "axis",
          // axisPointer: {
          //   type: 'shadow',
          //   shadowStyle: {
          //     color: "rgba(151, 30, 35, 0.1)",
          //   },
          // },
          // position: function (point, params, dom, rect, size) { // 提示框位置
          //   let x = 0;
          //   let y = 0;
          //   //提示框定位
          //   if (point[0] + size.contentSize[0] < size.viewSize[0]) {
          //     x = point[0]
          //   } else if (point[0] > size.contentSize[0]) {
          //     x = point[0] - size.contentSize[0]
          //   } else {
          //     x = "30%"
          //   }
          //   if (point[1] > size.contentSize[1]) {
          //     y = point[1] - size.contentSize[1]
          //   } else if (point[1] + size.contentSize[1] < size.viewSize[1]) {
          //     y = point[1]
          //   } else {
          //     y = "30%"
          //   }
          //   return [x, y];
          // },
          // textStyle: {
          //   color: "#fff",
          //   fontFamily: "Source Han Sans CN-Regular",
          // },
          // extraCssText: 'opacity: 0.8;background-color:#050F1B;padding:16px;box-shadow: 1px 6px 15px 1px rgba(0,0,0,0.13);border-radius: 4px;filter: blur(undefinedpx);border:none;'
        },
        legend: {
          data: dataName,
          // left: "16",
          top: "16px",
          //icon: "circle",
          itemWidth: 15, // 设置宽度
          itemHeight: 15, // 设置高度
          itemGap: 25,
          textStyle: {
            // color: '#A0AEC0',
            // fontFamily: 'Source Han Sans CN-Regular',
            // fontSize: 14,
            // padding: [0, 0, 0, 5]
          },
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            yAxisIndex: [0],
            left: "93%",
            start: 100,
            end: 70,
          },
        ],
        xAxis: [
          {
            type: "value",
            // axisLine: {
            //   show: false,
            // },
            // axisTick: {
            //   show: false,
            // },
          },
        ],
        yAxis: [
          {
            // boundaryGap: ['0%', '20%'],
            type: "category",
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            data: keys,
          },
        ],
        series: [
          {
            name: "危废计划产生量（吨）",
            label: {
              show: false,
            },
            type: "bar",
            data: planOutPuts,
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "实际产生量（吨）",
            label: {
              show: false,
            },
            type: "bar",

            data: outPuts,
            emphasis: {
              focus: "series",
            },
          },
        ],
      };
      const myChart = echarts.init(
        document.getElementById("planVsRealOutPut-chart")
      );
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawDangerDataCharts() {
      const keys = ["数量"];
      const disPos = this.companyDangerWasterData.disPos;
      const outPut = this.companyDangerWasterData.outPut;
      const storage = this.companyDangerWasterData.storage;

      const dataName = ["产生量", "处置量", "贮存量"];
      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: dataName,
          // left: "16",
          top: "16px",
          //icon: "circle",
          itemWidth: 15, // 设置宽度
          itemHeight: 15, // 设置高度
          itemGap: 25,
          textStyle: {
            // color: '#A0AEC0',
            // fontFamily: 'Source Han Sans CN-Regular',
            // fontSize: 14,
            // padding: [0, 0, 0, 5]
          },
        },

        xAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: "{value} 吨",
            },
          },
        ],
        yAxis: [
          {
            boundaryGap: ["100%"],
            type: "category",
            axisTick: {
              show: false,
            },
            axisLine: {
              //y轴线
              show: false,
            },
            data: keys,
          },
        ],
        series: [
          {
            name: "产生量",
            label: {
              show: false,
            },
            type: "bar",
            data: [outPut],
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "处置量",
            label: {
              show: false,
            },
            type: "bar",
            data: [disPos],
            emphasis: {
              focus: "series",
            },
          },

          {
            name: "贮存量",
            label: {
              show: false,
            },
            type: "bar",
            data: [storage],
            emphasis: {
              focus: "series",
            },
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("dangerData-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    drawDangerTypeCharts() {
      var xData = this.companyDangerTypeData.map((item) =>
        item.key.substring(0, 4)
      );
      var outPuts = this.companyDangerTypeData.map((item) => item.outPut);
      var disPos = this.companyDangerTypeData.map((item) => item.disPos);
      var storages = this.companyDangerTypeData.map((item) => item.storage);
      const legendData = ["产生量", "处置量", "贮存量"];
      const option = {
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: xData.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legendData,
          // align: "right",
          //   right: 10,
          top: "16px",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 35,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          top: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value} 吨",
            },
            axisTick: {
              show: false,
            },

            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "产生量",
            label: {
              show: false,
            },
            type: "bar",
            data: outPuts,
            emphasis: {
              focus: "series",
            },
          },
          {
            name: "处置量",
            label: {
              show: false,
            },
            type: "bar",
            data: disPos,
            emphasis: {
              focus: "series",
            },
          },

          {
            name: "贮存量",
            label: {
              show: false,
            },
            type: "bar",
            data: storages,
            emphasis: {
              focus: "series",
            },
          },
        ],
      };

      const myChart = echarts.init(document.getElementById("dangerType-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },

  mounted() {
    // 获取当前年份和月份
    const currentMonth = this.$dayjs().format("YYYY-MM");
    // 获取上个月的年份和月份
    const lastMonth = this.$dayjs().subtract(1, "month").format("YYYY-MM");

    this.dates.push(lastMonth, currentMonth);

    this.getParams();
  },
};
</script>

<style lang="scss" scoped>
.charts {
  height: 100%;
}

.chart-content {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - 60px);

  .chart-card {
    border: 1px solid #909399;
    width: 46%;
    margin: 10px 1%;
    height: calc(50% - 30px);
    border-radius: 3px;

    .chart-title {
      width: 100%;

      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-bottom: 1px solid #909399;
      padding: 0px 10px;
    }

    .chart-main {
      width: 100%;
      height: calc(100% - 45px);
    }
  }
}

.select-searchmain1 {
  width: 100%;
  height: 50px;
  display: flex;
  padding: 5px;
  box-sizing: content-box;

  .search-action {
    display: inline-block;
    // width: 230px;
    text-align: center;
    height: 100%;
    margin-right: 10px;
    // line-height: 70px;
  }

  .earch-input {
    flex-grow: 1;
    padding-left: 20px;

    p {
      width: 100%;
      height: 30px;
      line-height: 30px;
    }

    .input-li2 {
      margin-right: 20px;
      width: 350px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }

    .input-li {
      margin-right: 20px;
      width: 200px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }
  }
}
</style>
